import React from 'react';
import { PlusIconSVG } from './CardViewSVG';
import './DummyCard.scss';

const DummyCard = () => {
  return (
    <div aria-label="Add provider to compare" className="dummycard-container">
      <div className="plus-circle">
        <PlusIconSVG />
      </div>
    </div>
  );
};

export default DummyCard;
